import { api } from '../api/api.js';

declare global {
    interface Window {
        version: string;
    }
}

export type FormLog = {
    id?: number,
    created?: string,
    site_url?: string,
    http_code?: number,
    http_answer?: string,
    user_agent?: string,
    framework_version?: string,
}

export class FormLogger {
    /**
     * clones the response and logs it
     * @param response
     * @param log
     */
    static async logResponse(response: Response, log = true) {
        if (log === false) return response;

        console.log('response', response);
        await FormLogger.uploadLog(FormLogger.buildData({
            http_code: response.status,
            http_answer: await response.clone().text(),
        }));
        return response;
    }

    /**
     *
     * @param reason
     * @param log
     */
    static async logError(reason: any, log = true) {
        if (api.log === false) {
            if (reason instanceof Error) throw reason;
            return reason;
        }

        console.log('error', reason);
        await FormLogger.uploadLog(FormLogger.buildData({
            http_code: 0,
            http_answer: reason.toString(),
        }));
        if (reason instanceof Error) throw reason;
        return reason;
    }

    private static buildData(partial: FormLog) {
        return {
            site_url: document.URL,
            user_agent: navigator.userAgent,
            framework_version: window.version ?? null,
            ...partial,
        } as FormLog;
    }

    private static async uploadLog(data: FormLog) {
        try {
            api.log = false;
            await api.api_put('https://api.moxi.ch/api/form_logger/api.php', data);
        } catch (error) {
            console.error(error);
        }
    }
}
